export { requestDetailsEpic } from './epic';
